import { render, staticRenderFns } from "./PartnerModal.vue?vue&type=template&id=97e87a52"
import script from "./PartnerModal.vue?vue&type=script&lang=js"
export * from "./PartnerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports